const MAP = {
  Pending: { c: "#F59E0B", label: "Pending" },
  Approved: { c: "#10B981", label: "Approved" },
  Paid: { c: "#10B981", label: "Paid" },
  submitted: { c: "#F59E0B", label: "Submitted" },
  approved: { c: "#10B981", label: "Approved" },
  rejected: { c: "#EF4444", label: "Rejected" },
  open: { c: "#A1A1AA", label: "Open" },
  assigned: { c: "#3B82F6", label: "Assigned" },
  in_progress: { c: "#3B82F6", label: "In Progress" },
  on_hold: { c: "#F59E0B", label: "On Hold" },
  completed: { c: "#10B981", label: "Completed" },
  cancelled: { c: "#EF4444", label: "Cancelled" },
  pending_onboarding: { c: "#A1A1AA", label: "Onboarding" },
  onboarding_submitted: { c: "#F59E0B", label: "Awaiting Approval" },
  new: { c: "#F59E0B", label: "New" },
  followed_up: { c: "#3B82F6", label: "Followed Up" },
  archived: { c: "#A1A1AA", label: "Archived" },
};

export const StatusBadge = ({ status, testId }) => {
  const s = MAP[status] || { c: "#A1A1AA", label: status };
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-2 border px-3 py-1 text-xs uppercase tracking-[0.12em] font-medium"
      style={{ borderColor: s.c, color: s.c }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.c }} />
      {s.label}
    </span>
  );
};
